import { memo } from "react";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import CustomFormattedMessageContainer from "app/pages/.shared/CustomFormattedMessage/CustomFormattedMessageContainer";
import Popover from "app/components/ui/Popover/Popover";
import PaymentModesTooltipContainer from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentModes/PaymentModesTooltipContainer";
import "./PaymentDescription.scss";
import PropTypes from "prop-types";

const PaymentDescription = ({ availablePaymentMethods = [], message }) => {
	if (!message) {
		return null;
	}

	return (
		<div className="payment-description">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				variantMD={TYPOGRAPHY_VARIANTS.XL2}
				isBold
				className="payment-description__content"
			>
				<CustomFormattedMessageContainer
					message={message}
					className="payment-description__terms"
					children={
						<Popover iconSize={12}>
							<PaymentModesTooltipContainer paymentModes={availablePaymentMethods} />
						</Popover>
					}
					enableHTMLFormatting={true}
				/>
			</Typography>
		</div>
	);
};
PaymentDescription.propTypes = {
	availablePaymentMethods: PropTypes.array,
	message: PropTypes.string,
};

export default memo(PaymentDescription);
